<template>
    <div tabIndex="0" aria-label="Global Chat Alert Modal" class="global-chat-alert-modal">
        <div tabIndex="0" aria-label="this.alertModal.title" @keydown.tab="(e) => focusTrap(e)" class="global-chat-alert-modal__title">{{this.alertModal.title}}</div>
        <div tabIndex="0" class="global-chat-alert-modal__subtitle">{{this.alertModal.subtitle}}</div>
        
        <button @click="alertModalConfirm()" class="global-chat-alert-modal__confirm-button">
            {{this.alertModal.confirmText}}
        </button>
        
        <button @click="alertModalCancel()" @keydown.tab="(e) => focusTrap(e)" class="global-chat-alert-modal__cancel-button btn--inverted">
            {{this.alertModal.cancelText}}
        </button>
    </div>
</template>

<script>

    export default {
    
        props: ['alertModal'],
        
        methods: {
            alertModalConfirm: function () {
                this.$root.$emit('alert-modal-confirm');
            },

            alertModalCancel: function () {
                this.$root.$emit('alert-modal-cancel');
            },

            focusTrap: function (e) {
                if (e.target === $(".global-chat-alert-modal__cancel-button")[0] && !e.shiftKey) {
                    e.preventDefault();
                    $(".global-chat-alert-modal__title").trigger('focus')
                } else if (e.shiftKey && e.target === $(".global-chat-alert-modal__title")[0]) {
                    e.preventDefault();
                    $(".global-chat-alert-modal__cancel-button").trigger('focus');
                }
            }

        },
    }
</script>